import { ApolloProvider } from "@apollo/client";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { registerSW } from "virtual:pwa-register";
import { OnlineStatusProvider } from "context";
import { App } from "./App";
import { createApolloClient } from "./apollo/client";
import "leaflet/dist/leaflet.css";
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";
import "@thruhiker/ui/theme.scss";

const container = document.getElementById("root");
if (!container) throw new Error("Root element #root not found");

registerSW({ immediate: true });

async function bootstrap() {
  // Restore the persisted Apollo cache before first render (offline-first).
  const client = await createApolloClient();

  createRoot(container!).render(
    <StrictMode>
      <OnlineStatusProvider>
        <ApolloProvider client={client}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </ApolloProvider>
      </OnlineStatusProvider>
    </StrictMode>,
  );
}

void bootstrap();
